export var EPaymentStatusConstant = /*#__PURE__*/function (EPaymentStatusConstant) {
  EPaymentStatusConstant["StatusParameter"] = "topupPaymentStatus";
  EPaymentStatusConstant["ContinuePaymentParameter"] = "topupContinuePayment";
  EPaymentStatusConstant["OrderIdParameter"] = "orderId";
  EPaymentStatusConstant["Success"] = "success";
  EPaymentStatusConstant["Failure"] = "failure";
  EPaymentStatusConstant["LocalStorageParameter"] = "payment";
  return EPaymentStatusConstant;
}({});
export var ESberPaymentStatusConstant = /*#__PURE__*/function (ESberPaymentStatusConstant) {
  ESberPaymentStatusConstant["StatusParameter"] = "sberPayStatus";
  ESberPaymentStatusConstant["State"] = "state";
  ESberPaymentStatusConstant["OrderIdParameter"] = "bankInvoiceId";
  ESberPaymentStatusConstant["Success"] = "success";
  ESberPaymentStatusConstant["Failure"] = "cancel";
  return ESberPaymentStatusConstant;
}({});
export var EPaymentUrlParam = /*#__PURE__*/function (EPaymentUrlParam) {
  EPaymentUrlParam["Sum"] = "paymentSum";
  EPaymentUrlParam["AccountNumber"] = "paymentCtn";
  return EPaymentUrlParam;
}({});
export var TOPUP_WIDGET_OPEN_QUERY_PARAMETER = 'topupWidgetOpen';